// extracted by mini-css-extract-plugin
export default {"blank":"BlankBlock_blank__LQwOk","blank__container":"BlankBlock_blank__container__cxBIJ","blank__info":"BlankBlock_blank__info__Nvm-H"};